import { Cart, PromotionResult } from '@spartacus/cart/base/root';
import { CartGroupEntry, CustomOrder } from '../models';
import { CartGroupTypeEnum } from '../enums';

import '../models/augmented-spartacus-cart.model';

export function findStandaloneEntries(orderOrCart: CustomOrder | Cart): CartGroupEntry[] {
  if (orderOrCart) {
    return orderOrCart.entryGroups?.filter((standAlone) => standAlone.type === CartGroupTypeEnum.STANDALONE);
  }
  return [];
}

export function findBundleEntries(orderOrCart: CustomOrder | Cart): CartGroupEntry[] {
  if (orderOrCart) {
    return orderOrCart.entryGroups?.filter((bundle) => bundle.type === CartGroupTypeEnum.BUNDLE);
  }
  return [];
}

export function getProductEntryDiscount(orderOrEntry: CustomOrder | Cart): number {
  if (orderOrEntry) {
    if (orderOrEntry['discountApplied']?.[0]) {
      // eslint-disable-next-line no-unsafe-optional-chaining
      return parseFloat((orderOrEntry['discountApplied']?.[0]?.['appliedValue']).split(' ')[0].replace(',', '.'));
    } else {
      return orderOrEntry.appliedProductPromotions?.length > 0
        ? orderOrEntry.appliedProductPromotions[0]['promotionActions']?.[0]?.['amount']?.['value']
        : orderOrEntry.appliedOrderPromotions?.length > 0
          ? orderOrEntry.appliedOrderPromotions[0]['promotionActions']?.[0]?.['amount']?.['value']
          : 0;
    }
  }
  return 0;
}

export function getEntryDiscountForProduct(orderOrEntry: CustomOrder | Cart): number {
  if (orderOrEntry) {
    return orderOrEntry.appliedProductPromotions?.length > 0
      ? orderOrEntry.appliedProductPromotions[0]['promotionActions']?.[0]?.['amount']?.['value']
      : 0;
  }
  return 0;
}

export function getVoucherOperation(orderOrCart: CustomOrder | Cart): string {
  if (orderOrCart) {
    return orderOrCart.appliedOrderPromotions?.length > 0
      ? orderOrCart.appliedOrderPromotions[0]['promotionActions']?.[0]?.['usedCouponNames']?.[0]
      : orderOrCart.appliedProductPromotions?.length > 0
        ? orderOrCart.appliedProductPromotions[0]['promotionActions']?.[0]?.['usedCouponNames']?.[0]
        : '';
  }
  return '';
}

export function getVoucherDiscount(orderOrCart: CustomOrder | Cart): string {
  if (orderOrCart) {
    return orderOrCart.appliedOrderPromotions?.length > 0
      ? orderOrCart.appliedOrderPromotions[0]['promotionActions']?.[0]?.['amount']?.['value']
      : '';
  }
  return '';
}

export function getProductVoucherDiscount(orderOrCart: CustomOrder | Cart): string {
  if (orderOrCart) {
    return orderOrCart.appliedProductPromotions?.length > 0
      ? orderOrCart.appliedProductPromotions[0]['promotionActions']?.[0]?.['amount']?.['value']
      : '';
  }
  return '';
}

export function getVoucherCode(orderOrCart: CustomOrder | Cart): string {
  if (orderOrCart) {
    return getUsedCouponCode(orderOrCart.appliedOrderPromotions ?? []);
  }
  return '';
}

export function getProductVoucherCode(orderOrCart: CustomOrder | Cart): string {
  if (orderOrCart) {
    return getUsedCouponCode(orderOrCart.appliedProductPromotions ?? []);
  }
  return '';
}

function getUsedCouponCode(promotionsResults: PromotionResult[]) {
  for (const promotion of promotionsResults) {
    const usedCouponCode = promotion['promotionActions']?.[0]?.['usedCouponCodes']?.[0];
    if (usedCouponCode) {
      return usedCouponCode;
    }
  }
  return '';
}
